"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { MdStar } from "react-icons/md";
export default function FeedbackForm() {
  const $ = _c(68);
  const [rating, setRating] = useState(0);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      type: "",
      text: ""
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [message, setMessage] = useState(t0);
  const username = process.env.NEXT_PUBLIC_API_KEY_USER;
  const password = process.env.NEXT_PUBLIC_API_KEY_PASSWORD;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = btoa(`${username}:${password}`);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const token = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      name: "",
      email: "",
      mobile: "",
      comment: ""
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [formData, setFormData] = useState(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {};
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [errors, setErrors] = useState(t3);
  let t4;
  if ($[4] !== formData.comment || $[5] !== formData.email || $[6] !== formData.mobile || $[7] !== formData.name || $[8] !== rating) {
    t4 = () => {
      const newErrors = {};
      if (!formData.name.trim()) {
        newErrors.name = "Name is required.";
      }
      if (!formData.email.trim()) {
        newErrors.email = "Email is required.";
      } else {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
          newErrors.email = "Email is not valid.";
        }
      }
      if (!formData.mobile.trim()) {
        newErrors.mobile = "Mobile number is required.";
      } else {
        if (!/^\+?[0-9]{2,18}$/.test(formData.mobile)) {
          newErrors.mobile = "Enter a valid mobile number (2\u201318 digits).";
        }
      }
      if (!formData.comment.trim()) {
        newErrors.comment = "Feedback is required.";
      }
      if (rating === 0) {
        newErrors.rating = "Please give a rating.";
      }
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };
    $[4] = formData.comment;
    $[5] = formData.email;
    $[6] = formData.mobile;
    $[7] = formData.name;
    $[8] = rating;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const validate = t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = e => {
      setFormData(prev => ({
        ...prev,
        [e.target.name]: e.target.value
      }));
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleChange = t5;
  let t6;
  if ($[11] !== formData || $[12] !== rating || $[13] !== validate) {
    t6 = async e_0 => {
      e_0.preventDefault();
      if (!validate()) {
        return;
      }
      const payload = {
        ...formData,
        mark: rating
      };
      ;
      try {
        const res = await fetch(`${process.env.NEXT_PUBLIC_BASE_URL}/api/add-feedback`, {
          method: "POST",
          headers: {
            Authorization: `Basic ${token}`,
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        });
        if (res.ok) {
          setMessage({
            type: "success",
            text: "Feedback submitted successfully!"
          });
          setFormData({
            name: "",
            email: "",
            mobile: "",
            comment: ""
          });
          setRating(0);
          setErrors({});
        } else {
          setMessage({
            type: "error",
            text: "Something went wrong."
          });
        }
      } catch (t7) {
        setMessage({
          type: "error",
          text: "Submission failed."
        });
      }
    };
    $[11] = formData;
    $[12] = rating;
    $[13] = validate;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const handleSubmit = t6;
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Label htmlFor="name" className="pl-1">Name</Label>;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== formData.name) {
    t8 = <Input id="name" name="name" value={formData.name} onChange={handleChange} className="border-transparent shadow-none pl-1" />;
    $[16] = formData.name;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== errors.name) {
    t9 = errors.name && <p className="text-red-500 text-sm pl-1">{errors.name}</p>;
    $[18] = errors.name;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = <div className="ftv-field mt-5">{t7}{t8}{t9}</div>;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Label htmlFor="email" className="pl-1">Email</Label>;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== formData.email) {
    t12 = <Input id="email" name="email" value={formData.email} onChange={handleChange} className="border-transparent shadow-none pl-1" />;
    $[24] = formData.email;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== errors.email) {
    t13 = errors.email && <p className="text-red-500 text-sm pl-1">{errors.email}</p>;
    $[26] = errors.email;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t12 || $[29] !== t13) {
    t14 = <div className="ftv-field mt-5">{t11}{t12}{t13}</div>;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Label htmlFor="mobile" className="pl-1">Phone</Label>;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== formData.mobile) {
    t16 = <Input id="mobile" name="mobile" value={formData.mobile} onChange={handleChange} className="border-transparent shadow-none pl-1" />;
    $[32] = formData.mobile;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== errors.mobile) {
    t17 = errors.mobile && <p className="text-red-500 text-sm pl-1">{errors.mobile}</p>;
    $[34] = errors.mobile;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t16 || $[37] !== t17) {
    t18 = <div className="ftv-field mt-5">{t15}{t16}{t17}</div>;
    $[36] = t16;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Label htmlFor="comment" className="pl-1">Describe Your Feedback</Label>;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== formData.comment) {
    t20 = <Textarea id="comment" name="comment" value={formData.comment} onChange={handleChange} placeholder="Type your message here." />;
    $[40] = formData.comment;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== errors.comment) {
    t21 = errors.comment && <p className="text-red-500 text-sm pl-1">{errors.comment}</p>;
    $[42] = errors.comment;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t20 || $[45] !== t21) {
    t22 = <div className="ftv-field mt-5">{t19}{t20}{t21}</div>;
    $[44] = t20;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Label htmlFor="mark" className="pl-1">Rating</Label>;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = [1, 2, 3, 4, 5];
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== rating) {
    t25 = <div id="mark" className="flex gap-2 my-3">{t24.map(num => <MdStar key={num} className={num <= rating ? "text-green-500" : "text-gray-300"} onClick={() => setRating(num)} style={{
        cursor: "pointer"
      }} />)}</div>;
    $[49] = rating;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== errors.rating) {
    t26 = errors.rating && <p className="text-red-500 text-sm pl-1">{errors.rating}</p>;
    $[51] = errors.rating;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t25 || $[54] !== t26) {
    t27 = <div className="ftv-field mt-5">{t23}{t25}{t26}</div>;
    $[53] = t25;
    $[54] = t26;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  let t28;
  if ($[56] !== message.text || $[57] !== message.type) {
    t28 = message.text && <div className={`mt-4 p-3 rounded text-center ${message.type === "success" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>{message.text}</div>;
    $[56] = message.text;
    $[57] = message.type;
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  let t29;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <div className="w-full text-center"><button type="submit" className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 mt-4 rounded">Submit</button></div>;
    $[59] = t29;
  } else {
    t29 = $[59];
  }
  let t30;
  if ($[60] !== handleSubmit || $[61] !== t10 || $[62] !== t14 || $[63] !== t18 || $[64] !== t22 || $[65] !== t27 || $[66] !== t28) {
    t30 = <form onSubmit={handleSubmit}>{t10}{t14}{t18}{t22}{t27}{t28}{t29}</form>;
    $[60] = handleSubmit;
    $[61] = t10;
    $[62] = t14;
    $[63] = t18;
    $[64] = t22;
    $[65] = t27;
    $[66] = t28;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  return t30;
}